import i18n from '@/plugins/i18n'

export const reports=[
    // {
    //     value: '1',
    //     text: i18n.t('registered_student_count_by_school'),
    //     permission:'studentreport_registrationnumbersbyfaculty'
    // },
    {
        value: '9',
        text: i18n.t('current_students_not_registered'),
        permission: 'studentreport_studentsnotenrolledcourselistreport'
    },
    /*{
        value: '10',
        text: i18n.t('number_of_courses_enrolled_by_student'),
        permission:'studentreport_studentsyearlycourselistreport'
    },*//*
    {
        value: '11',
        text: i18n.t('number_of_students_that_must_take_the_core_courses'),
        permission: 'studentreport_studentsmustcourselistreport'
    },*/
    {
        value: '12',
        text: i18n.t('students_who_are_likely_to_graduate_in_the_next_3_semesters'),
        permission: 'studentreport_studentsmustcourselistreport'

    },
    {
        value: '13',
        text: i18n.t('students_who_are_likely_to_graduate_in_the_next_2_semesters'),
        permission: 'studentreport_studentsgraduateinthetwosemestersreport'
    },
    {
        value: '14',
        text: i18n.t('students_who_are_likely_to_graduate_next_semester'),
        permission: 'studentreport_studentsgraduateinthenextsemesterreport'
    },
    {
        value: '15',
        text: i18n.t('students_who_are_likely_to_graduate_in_the_current_semester'),
        permission: 'studentreport_studentsgraduateinthecurrentsemesterreport'
    },
    {
        value: '16', text: i18n.t('sap_report'),
        permission: 'studentsemester_sapreport'
    },
    {
        value: '23',
        text: i18n.t('registrar_report'),
        permission: 'studentreport_registrarreport'
    },
    {
        value: '24',
        text: i18n.t('course_approval_report'),
        permission: 'studentreport_courseapprovalcheckreport'
    },/*
    {
        value: '25',
        text: i18n.t('course_registration'),
        permission:'studentcourse_studentcourseincludedreport'
    },*/
    {
        value: '26',
        text: i18n.t('financial_registration_report'),
        permission: 'studentreport_registrationreport'
    },/*
    {
        value: '27',
        text: "Attendance Entry Tracking Report",
        permission: 'dailyattendance_entrytrackingreport'
    },*/
    {
        value: '28',
        text: i18n.t('missing_documents_report'),
        permission: 'studentprogram_missingdocumentexcelexport'
    },
    {
        value: '29',
        text: i18n.t('student_reports_parchment_report'),
        permission: 'studentreport_parchmentreport'
    },
    {
        value: '30',
        text: 'Unexcused Absences Tracker Report',
        permission: 'dailyattendance_getdailyattendancereport'
    },
    {
        value: '32',
        text: i18n.t('financial_registration_by_Agency'),
        permission: 'studentreport_financialreport'
    },
    {
        value: '33',
        text: i18n.t('president_list_report'),
        permission: 'studentreport_presidentlistreport'
    },
    /*{
        value: '34',
        text: i18n.t('curriculum_credits_report'),
        permission: 'studentreport_studentcurriculumcreditsreport'
    },*/
   /* {
        value: '35',
        text: i18n.t('ie_reporting'),
        permission: 'studentreport_iereporting'
    },*/
    {
        value: '36',
        text: i18n.t('dso_registration_report'),
        permission: 'studentreport_dsoregistrationreport'
    },
    {
        value: '37',
        text: i18n.t('transfer_out_data'),
        permission: 'studentprogram_studenttransferoutdataexcelexport'
    },
    {
        value: '38',
        text: i18n.t('student_photos_report'),
        permission: 'studentreport_studentphotosreport'
    },
    {
        value: '39',
        text: i18n.t('missing_enrollment_agreements_report'),
        permission: 'studentreport_missingenrollmentagreement'
    },
    {
        value: '40',
        text: i18n.t('media_opt_out_report'),
        permission: 'studentreport_mediaoptout'
    },


]
